/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../api/types.generated";
export type GetEventMetaQueryVariables = Types.Exact<{
  slug: Types.Scalars["String"];
}>;

export type GetEventMetaQuery = Pick<Types.Query, "eventMeta">;

export const GetEventMetaDocument = gql`
  query GetEventMeta($slug: String!) {
    eventMeta(slug: $slug)
  }
`;

/**
 * __useGetEventMetaQuery__
 *
 * To run a query within a React component, call `useGetEventMetaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventMetaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventMetaQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetEventMetaQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetEventMetaQuery,
    GetEventMetaQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    GetEventMetaQuery,
    GetEventMetaQueryVariables
  >(GetEventMetaDocument, baseOptions);
}
export function useGetEventMetaLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetEventMetaQuery,
    GetEventMetaQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    GetEventMetaQuery,
    GetEventMetaQueryVariables
  >(GetEventMetaDocument, baseOptions);
}
export type GetEventMetaQueryHookResult = ReturnType<
  typeof useGetEventMetaQuery
>;
export type GetEventMetaLazyQueryHookResult = ReturnType<
  typeof useGetEventMetaLazyQuery
>;
export type GetEventMetaQueryResult = ApolloReactCommon.QueryResult<
  GetEventMetaQuery,
  GetEventMetaQueryVariables
>;
